__turbopack_context__.v({
  "followEmptySlot": "FollowButton-module-scss-module__8fFmFa__followEmptySlot",
  "followFollowingSlot": "FollowButton-module-scss-module__8fFmFa__followFollowingSlot",
  "followPrimarySlot": "FollowButton-module-scss-module__8fFmFa__followPrimarySlot",
  "spin": "FollowButton-module-scss-module__8fFmFa__spin",
  "spinner": "FollowButton-module-scss-module__8fFmFa__spinner",
});
